import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import AttributeDef from 'models/configuration/attribute_def';
import CustomAttributeBase from './custom_attribute_base';
import EditableFieldControlled from 'components/lib/editable_field_controlled';
import UpdateCustomAttributes from 'actions/customer_profile/update_custom_attributes';

function EditableStringCustomAttribute({ def, value, isDisabled, isResponsePending, onSubmit }) {
  if (def.type !== 'STRING') {
    return null;
  }

  let renderedValue = (
    <EditableFieldControlled
      className="editableStringCustomAttribute-input"
      disabled={isDisabled}
      pending={isResponsePending}
      readOnly={false}
      onSubmit={onSubmit}
      value={value || ''}
    />
  );

  return (
    <CustomAttributeBase className="editableCustomAttribute" label={def.label}>
      {renderedValue}
    </CustomAttributeBase>
  );
}

EditableStringCustomAttribute.propTypes = {
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  isResponsePending: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export { EditableStringCustomAttribute };

const EditableStringCustomAttributeContainer = connect(
  mapStateToProps,
  mapExecuteToProps
)(EditableStringCustomAttribute);

function mapStateToProps({ getProvider }, { def }) {
  let profileProvider = getProvider('profile');

  return {
    def,
    value: _.get(profileProvider.get(), ['customAttributes', def.attr]),
    isDisabled: profileProvider.isLoading() || !_(profileProvider.getErrors()).isEmpty(),
    isResponsePending: profileProvider.isPending(),
  };
}

function mapExecuteToProps(executeAction, { def }) {
  return {
    onSubmit: value => executeAction(UpdateCustomAttributes, { [def.attr]: value }),
  };
}

export default EditableStringCustomAttributeContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/editable_string_custom_attribute.jsx